
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface ColorSettingsProps {
    colors: { [key: string]: string };
    onColorChange: (colorName: string, value: string) => void;
}

const colorLabels: { [key: string]: string } = {
    primary: 'اللون الأساسي',
    text: 'لون النص',
    background: 'لون الخلفية'
};

export function ColorSettings({ colors, onColorChange }: ColorSettingsProps) {
    return (
        <div className="space-y-4">
            {Object.entries(colors).map(([key, value]) => (
                <div key={key} className="flex items-center justify-between">
                    <Label htmlFor={`${key}-color-picker`}>
                        {colorLabels[key] || key}
                    </Label>
                    <div className="flex items-center gap-2">
                        <Input
                            id={`${key}-color-picker`}
                            type="color"
                            value={value}
                            onChange={(e) => onColorChange(key, e.target.value)}
                            className="p-1 h-8 w-8 cursor-pointer"
                        />
                        <span className="text-sm text-gray-500 font-mono">{value}</span>
                    </div>
                </div>
            ))}
        </div>
    );
}
